import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Leaf } from "lucide-react";
import Seo from "@/components/Seo";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const redirect = sp.get("redirect");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) nav(redirect || (res.user.role === "admin" ? "/admin" : "/account"));
  };

  return (
    <div data-testid="login-page" className="mx-auto max-w-md px-4 py-16">
      <Seo title="Login" path="/login" noindex={true} />
      <div className="text-center">
        <div className="mx-auto w-12 h-12 rounded-full bg-[var(--yp-primary)] text-white grid place-items-center"><Leaf /></div>
        <h1 className="font-serif-display text-3xl text-[var(--yp-primary)] mt-4">Welcome back</h1>
        <p className="text-[var(--yp-muted)] text-sm">Sign in to your YourPlants account</p>
      </div>
      <form onSubmit={submit} className="mt-8 bg-white border border-[var(--yp-border)] rounded-2xl p-6 space-y-4">
        <div>
          <label className="text-xs uppercase tracking-widest text-[var(--yp-muted)]">Email</label>
          <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full border border-[var(--yp-border)] rounded-xl px-3 py-2.5 text-sm outline-none focus:border-[var(--yp-primary)]" />
        </div>
        <div>
          <label className="text-xs uppercase tracking-widest text-[var(--yp-muted)]">Password</label>
          <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 w-full border border-[var(--yp-border)] rounded-xl px-3 py-2.5 text-sm outline-none focus:border-[var(--yp-primary)]" />
        </div>
        <button data-testid="btn-login" disabled={loading} className="w-full btn-primary rounded-full py-3 text-sm font-medium disabled:opacity-70">
          {loading ? "Signing in…" : "Sign in"}
        </button>
        <div className="text-center text-sm text-[var(--yp-muted)]">
          New here? <Link to="/register" data-testid="link-to-register" className="text-[var(--yp-primary)] hover:underline font-medium">Create an account</Link>
        </div>
      </form>
    </div>
  );
}
